import { brandFor } from "@/lib/careers/brands";

const SIZES = { xs: { box: 20, img: 14 }, sm: { box: 36, img: 26 }, md: { box: 44, img: 32 }, lg: { box: 56, img: 40 } };

export const CompanyMark = ({ company, size = "sm", testId }) => {
  const brand = brandFor(company);
  const dims = SIZES[size] || SIZES.sm;
  return (
    <span data-testid={testId} aria-hidden="true" className="shrink-0 inline-flex items-center justify-center overflow-hidden border" style={{ width: dims.box, height: dims.box, background: brand.tile, borderColor: brand.color === "#D9FE33" ? "#C5E82E" : brand.tint }}>
      {brand.logo ? <img src={brand.logo} alt="" width={dims.img} height={dims.img} className="object-contain" style={{ width: dims.img, height: dims.img }} loading="lazy" />
        : <span className="font-display font-bold" style={{ color: brand.text, fontSize: dims.img * 0.55 }}>{(company || "?").slice(0, 1)}</span>}
    </span>
  );
};
